import { Component, OnDestroy, Input, OnInit } from "@angular/core";
import { IWizardContentComponent } from "../../../wizard.content";


@Component({
  selector: "sites-create-html",
  templateUrl: "./sites.create.html",
  styleUrls: ['../wizard.sites.style.scss', './sites.create.style.scss'],
  providers: [
  ]
})
export class SitesCreateHtmlComponent implements OnInit, OnDestroy, IWizardContentComponent {

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl:any;
  // the template sites.create refers directly to wizardService/output data structure
  // this is very bad practise/must be eliminated! wizard developers should never update output structure
  // directly/it must be updated by wizard service itself, reacting to output events from components.
  // I add this variable to make the template operational - but please refactor the template asap.

  wizardService:any;
  isUploadEnabled: boolean;
  siteImagePath:string;

  constructor() {
  }

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.isUploadEnabled = this.wizardService.showUploadSites;
    this.siteImagePath = "images/site.svg";
  }

  ngOnDestroy() {
  }

}
